module.exports = __webpack_public_path__ + "static/img/menu_dialog.115d55d.png";